import Vue from 'vue'
import masker from '@/shared/mask/masker'
import moment from 'vue-moment-lib'

Vue.filter('toCnpj', value => {
    return masker(value, '##.###.###/####-##')
})

Vue.filter('toCpf', value => {
    return masker(value, '###.###.###-##')
})

Vue.filter('toCpfCnpj', value => {
    return masker(value, ['##.###.###/####-##', '###.###.###-##'])
})

Vue.filter('toNirf', value => {
    return masker(value, ['#.###.###-#'])
})

Vue.filter('toSicab', value => {
    return masker(value, ['AA.####.#######.##'])
})

Vue.filter('toStatus', value => {
    return `<strong>${value}</strong>`
})

Vue.filter('toTelefone', value => {
    return masker(value, ['(##) #####-####', '(##) ####-####'])
})

Vue.filter('toCep', value => {
    return masker(value, '#####-###')
})

Vue.filter('toDate', value => {
    return value ? moment(value).format('DD/MM/YYYY') : ''
})

Vue.filter('toDateTime', value => {
    return value ? moment(value).format('DD/MM/YYYY HH:mm') : ''
})

Vue.filter('toCurrency', value => {
    if (!value) return 'R$ 0,00'
    
    // Converte para number se for string
    const numValue = typeof value === 'string' ? parseFloat(value) : value
    
    // Formata para moeda brasileira
    return numValue.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })
})
